import logo from './logo.svg';
import './App.css';
import AppForm from './components/AppForm.js'

function App() {
  return (
    <div className="container" style={{backgroundColor: "white"}}>
      <header className="">
        <h1>
          UAN Equipment Refresh 2025
        </h1>
      </header>
      <AppForm />
    </div>
  );
}

export default App;
